/* eslint-disable react-hooks/exhaustive-deps */
import {
  useNavigation,
  useFocusEffect,
  useIsFocused,
} from "@react-navigation/native";
import React, { useCallback, useMemo, useState } from "react";
import {
  ActivityIndicator,
  StyleSheet,
  TouchableNativeFeedback,
  View,
  SectionList,
} from "react-native";

import Cross from "@assets/svg/Cross";
import Info from "@assets/svg/MyDeliveries/Info";
import CustomText from "@components/CustomText";
import colors from "@constants/color";
import { getComboItems } from "@services/api";
import CrateCard from "./CrateCard";

const ComboReturn = ({ route }) => {
  const navigation = useNavigation();
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(true);
  const [comboItems, setComboItems] = useState({ data: [] });

  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
    }, [isFocused]),
  );

  const fetchData = async () => {
    try {
      const { data } = await getComboItems({
        order_item_id: route?.params?.order_item_id,
        item_number: route?.params?.item_number,
        type: "SUMMARY",
      });
      setComboItems(data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const renderItem = useCallback(({ item }) => {
    return (
      <>
        <CrateCard info={item} fetchData={fetchData} isComboReturn={true} />
        <View style={externalStyles.horizontalSeparator} />
      </>
    );
  }, []);

  const Title = () => {
    return (
      <View style={externalStyles.titleContainer}>
        <View style={externalStyles.titleInnerContainer}>
          <View style={externalStyles.iconContainer}>
            <Info height={24} width={24} color={colors.plain_amber} />
          </View>
          <View style={externalStyles.titleTextContainer}>
            <CustomText variant="title_16" style={externalStyles.titleText}>
              {comboItems?.meta?.WarningModal?.title}
            </CustomText>
          </View>
        </View>
      </View>
    );
  };

  const Header = () => (
    <View style={externalStyles.headerContainer}>
      <TouchableNativeFeedback
        testID="cut"
        onPress={() => navigation.pop(route?.params?.pop_back || 0)}
      >
        <View>
          <Cross width={22} height={22} />
        </View>
      </TouchableNativeFeedback>
    </View>
  );

  const sortUpdates = useMemo(() => {
    return comboItems?.data.map((v) => {
      return {
        ...v,
        data: v?.items,
      };
    });
  }, [comboItems]);

  const keyExtractor = (item, index) => `${index}`;

  return (
    <View style={externalStyles.container}>
      <Header />
      {isLoading ? (
        <View style={externalStyles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <View style={externalStyles.contentContainer}>
          <SectionList
            sections={sortUpdates}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            ListHeaderComponent={comboItems?.meta ? Title : () => <></>}
            keyboardShouldPersistTaps="handled"
          />
          <View style={externalStyles.bottomButtonContainer}>
            <TouchableNativeFeedback
              testID="aage_badhe"
              onPress={() => navigation.pop(route?.params?.pop_back || 0)}
            >
              <View style={externalStyles.bottomButton}>
                <CustomText
                  variant="title_16"
                  style={externalStyles.bottomButtonText}
                >
                  आगे बढ़ें
                </CustomText>
              </View>
            </TouchableNativeFeedback>
          </View>
        </View>
      )}
    </View>
  );
};

const externalStyles = StyleSheet.create({
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
  container: {
    flex: 1,
  },
  headerContainer: {
    padding: 16,
    backgroundColor: colors.white,
    flexDirection: "row",
  },
  titleContainer: {
    marginHorizontal: 16,
    marginTop: 24,
    padding: 12,
    backgroundColor: "rgba(255, 242, 229, 1)",
    borderRadius: 10,
  },
  titleInnerContainer: {
    flexDirection: "row",
  },
  titleTextContainer: {
    flex: 1,
  },
  iconContainer: {
    marginTop: 5,
  },
  titleText: {
    marginLeft: 8,
    color: colors.darkText,
  },
  contentContainer: {
    flex: 1,
    backgroundColor: colors.white,
  },
  bottomButtonContainer: {
    backgroundColor: colors.white,
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingHorizontal: 16,
  },
  bottomButton: {
    marginBottom: 10,
    backgroundColor: "rgba(0, 171, 89, 1)",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
  bottomButtonText: {
    color: colors.white,
  },
  horizontalSeparator: {
    backgroundColor: colors.lightGray,
    height: 1,
    paddingHorizontal: 16,
  },
});

export default ComboReturn;
